<template>
  <div class="vx-row">
    <div class="vx-col w-full lg:w-1/1 lg:mt-0 md:mt-4 mb-4">
      <p v-if="showProductSelection">Select card</p>
      <vs-dropdown v-if="showProductSelection" vs-trigger-click class="cursor-pointer" style="min-width:200px">
        <div class="p-4 shadow border border-solid d-theme-border-grey-light d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
          <span class="mr-2">{{ actionDropdownTitle }}</span>
          <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
        </div>
        <vs-dropdown-menu class="search-page__more-dropdown">
          <vs-dropdown-item
            v-for="item in productOptions"
            :key="item.title"
            @click="changeProduct(item)"
            >
            {{ item.title }}
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>
    <div class="vx-col w-full mb-base mt-2">
      <h3>Tag Actions</h3>
    </div>
    <div class="vx-col w-full lg:w-1/2 lg:mt-0 mt-base">
      <div class="vx-row mb-4">
        <div class="vx-col w-full">
          <action-card :key="'card'" :action-data="action1Data" :tagName="cardDocId" :userId="userId" :tagTitle="actionDropdownTitle" />
        </div>
      </div>
    </div>
    <div class="vx-col w-full lg:w-1/2 lg:mt-0 mt-base">
      <div class="vx-row mb-4">
        <div class="vx-col w-full">
          <action-card :key="'keyring'" :action-data="action2Data" :tagName="keyringDocId" :userId="userId" :tagTitle="actionDropdownTitle" />
        </div>
      </div>
    </div>
    <div v-if="showProductSelection && actionDropdownTitle !== 'Primary Card'" class="vx-col w-full lg:w-1/1 lg:mt-0 md:mt-4 mb-4">
      <div class="vx-col w-full mb-base mt-2">
        <h3>Edit Card Name</h3>
      </div>
      <vs-textarea height="40px" width="300px" v-model="cardTitle" />
      <vs-button @click="updateCardTitle">Save</vs-button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ActionCard from './Actions/ActionCard.vue'

export default {
  components: {
    ActionCard
  },
  data () {
    return {
      userId: '',
      action1Data: {},
      action2Data: {},
      actionDropdownTitle: '',
      showProductSelection: false,
      productOptions: [],
      cardDocId: '',
      keyringDocId: '',
      cardTitle: ''
    }
  },
  computed: mapState(['AppActiveUser']),
  created () {
    this.cardDocId = 'card'
    this.keyringDocId = 'keyring'

    if (this.AppActiveUser.uid === 0) {
      this.unsubscribe = this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'UPDATE_USER_INFO') {
          if (state.AppActiveUser !== 0) {
            this.getUserProducts(true)
            this.getDetails()
            this.userId = this.AppActiveUser.uid
          }
        }
      })
    } else {
      this.getUserProducts(true)
      this.getDetails()
      this.userId = this.AppActiveUser.uid
    }
  },
  methods: {
    getUserProducts (refresh) {
      this.$fs.collection('client').doc(this.AppActiveUser.uid).collection('actions').get()
        .then(actionsData => {
          if (actionsData.docs.length > 2) {
            this.showProductSelection = true
            if (refresh) {
              this.actionDropdownTitle = actionsData.docs[0].data().title
              this.cardTitle = actionsData.docs[0].data().title
            } else {
              this.actionDropdownTitle = actionsData.docs.find(el => el.id === this.cardDocId).data().title
              this.cardTitle = actionsData.docs.find(el => el.id === this.cardDocId).data().title
            }
            actionsData.docs.forEach(doc => {
              if (doc.data().title !== undefined && !doc.data().title.includes('Keyring')) {
                this.productOptions.push({
                  id: doc.id,
                  title: doc.data().title
                })
              }
            })
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    updateCardTitle () {
      if (this.cardTitle.length > 4) {
        this.$fs.collection('client').doc(this.AppActiveUser.uid).collection('actions').doc(this.cardDocId).update({
          title: this.cardTitle
        })
          .then(() => {
            this.$vs.notify({
              title: 'Done',
              text: `New card name '${this.cardTitle}' has been set`,
              iconPack: 'feather',
              icon: 'icon-check-circle',
              color: 'success',
              position: 'top-center'
            })
            this.productOptions = []
            this.getUserProducts(false)
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        this.$vs.notify({
          title: 'Oops',
          text: 'New card name must be at least 4 characters',
          iconPack: 'feather',
          icon: 'icon-check-circle',
          color: 'danger',
          position: 'top-center'
        })
      }
    },
    changeProduct (item) {
      this.actionDropdownTitle = item.title
      this.cardTitle = item.title
      this.cardDocId = item.id
      this.keyringDocId = `keyring${item.id.substr(item.id.length - 1)}`
      this.getDetails()
    },
    getDetails () {
      this.$fs.collection('client').doc(this.AppActiveUser.uid).collection('actions').doc(this.cardDocId).get()
        .then(actionData => {
          this.action1Data = actionData.data()
        })
        .catch(error => {
          console.log(error)
        })

      this.$fs.collection('client').doc(this.AppActiveUser.uid).collection('actions').doc(this.keyringDocId).get()
        .then(actionData => {
          this.action2Data = actionData.data()
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>
